import { debounce } from 'lodash';

export default {
  data() {
    const noFilterItem = { value: 'no-filter', text: 'No Filter' };
    const missingPlanningItem = { value: 'missing-planning', text: 'Missing Planning' };
    const data = {
      filter: noFilterItem,
      filters: [noFilterItem, missingPlanningItem],
    };
    data.filters.default = noFilterItem;
    return data;
  },
  methods: {
    getFilters() {
      return this.filters;
    },
    getFilter(field) {
      if (!this.filter) {
        return undefined;
      }
      return field ? this.filter[field] : this.filter;
    },
    setFilterDebounce(filter) {
      if (filter !== this.filter) {
        this.$startLoading('filters');
        this._setFilterDebounce(filter);
      }
    },
    _setFilterDebounce: debounce(function setFilterDebounce(filter) {
      this.setFilter(filter);
      this.$stopLoading('filters');
    }, 200),
    setFilter(filter) {
      this.filter = filter;
    },
    setNoFilterItem(text) {
      this.filters.find(({ value }) => value === 'no-filter').text = text;
    },
    setMissingPlanningItem(text) {
      this.filters.find(({ value }) => value === 'missing-planning').text = text;
    },
    getDefaultFilter() {
      return this.filters.default;
    },
    setDefaultFilter(filter) {
      this.filters.default = filter;
    },
  },
  watch: {
    filter() {
      if (!this.filter) {
        this.$nextTick(() => {
          this.setFilter(this.getDefaultFilter());
        });
      }
    },
  },
};
